import styled from "styled-components";
import {
  MessageBar,
  MessageBarType,
  TooltipHost,
} from "@fluentui/react";
import React, { useContext } from "react";
import { ColumnOptionsContext } from "./ColumnOptions";

type Props = {
  className?: string;
};

export const ViewDescription = ({ className }: Props) => {
  const { selectedView } = useContext(ColumnOptionsContext);

  if (!selectedView?.description) return null;

  return (
    <TooltipHost content={selectedView.description}>
      <StyledMessageBar
        messageBarType={MessageBarType.info}
        isMultiline={false}
        className={className}
      >
        <DescriptionText>{selectedView.description}</DescriptionText>
      </StyledMessageBar>
    </TooltipHost>
  );
};

const StyledMessageBar = styled(MessageBar)`
  flex: 1;
  overflow: hidden;
`;

const DescriptionText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
`;
